import {
  SELECT_CHARITY,
  DETAILS_ADD_FIELD,
  DETAILS_DELETE_FIELD,
  DETAILS_ONCHANGE,
  DETAILS_ONBLUR,
  MESSAGE_ONCHANGE,
  PAYMENT_ONCHANGE,
  PAYMENT_ONBLUR,
  HTTP_REQUEST,
  HTTP_SUCCESS,
  HTTP_ERROR,
  DONATION_REQUEST_INIT,
  DONATION_REQUEST_SUCCESS,
  DONATION_REQUEST_ERROR,
  RESET_GLOBAL_STATE,
  RESPONSE_FETCH_REQUEST,
  RESPONSE_FETCH_SUCCESS,
  RESPONSE_FETCH_ERROR
} from "../constants/constants.js";

const ccMasks = {
  VI: {
    number: "9999 9999 9999 9999",
    cvv: "999"
  },
  MC: {
    number: "9999 9999 9999 9999",
    cvv: "999"
  },
  AX: {
    number: "9999 999999 99999",
    cvv: "9999"
  },
  DI: {
    number: "9999 9999 9999 99",
    cvv: "999"
  }
};
const getMonths = () => {
  return [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
};

const getYears = () => {
  let arrYears = [];
  const today = new Date();
  const startYear = today.getFullYear() - 2000;
  for (let i = 0; i < 10; i++) {
    arrYears.push(startYear + i);
  }
  return arrYears;
};

const getCardType = num => {
  if (!num) return false;
  num = num.toString();
  var numbers = {
    VI: ["4"],
    MC: [
      "50",
      "51",
      "52",
      "53",
      "54",
      "55",
      "5018",
      "5020",
      "5038",
      "5612",
      "5893",
      "6304",
      "6759",
      "6761",
      "6762",
      "6763",
      "0604",
      "6390"
    ],
    AX: ["34", "37"],
    DI: [
      "36",
      "38",
      "39",
      "54",
      "55",
      "300",
      "301",
      "302",
      "303",
      "304",
      "305",
      "309",
      "2014",
      "2149",
      "6100"
    ]
  };
  for (var type in numbers) {
    var arrKeys = numbers[type];
    for (var i = 0; i < arrKeys.length; i++) {
      var key = arrKeys[i].toString();
      if (num.substring(0, key.length) == key) {
        return type;
      }
    }
  }
  return false;
};

const checkCreditCard = value => {
  if (!value) return false;
  // accept only digits, dashes or spaces
  if (/[^0-9-\s]+/.test(value)) return false;

  // The Luhn Algorithm. It's so pretty.
  var nCheck = 0,
    nDigit = 0,
    bEven = false;
  value = value.replace(/\D/g, "");

  for (var n = value.length - 1; n >= 0; n--) {
    var cDigit = value.charAt(n),
      nDigit = parseInt(cDigit, 10);

    if (bEven) {
      if ((nDigit *= 2) > 9) nDigit -= 9;
    }

    nCheck += nDigit;
    bEven = !bEven;
  }

  return nCheck % 10 == 0;
};

const validators = {
  name: value => value.length > 1 && new RegExp(/^([^0-9]*)$/).test(value),
  phone: value => value.length > 1 && new RegExp(/\d{10}/).test(value),
  zip: value => value.length > 1 && new RegExp(/\d{5}/).test(value),
  expiryDate: value => {
    const month = parseInt(value.split("/")[0].trim()),
      year = parseInt(value.split("/")[1].trim()),
      today = new Date();
    if (today.getFullYear() === year && month <= today.getMonth() + 1)
      return false;
    return getMonths().includes(month) && getYears().includes(parseInt(year));
  }
};

const isDev = __ENV__ !== "production";
const initialState = {
  version: __VERSION__,
  transactionId: Math.pow(36, Math.random())
    .toString(36)
    .slice(2),
  charity: {},
  personal: {
    firstName: [{ type: "text", value: isDev ? "First" : "" }],
    lastName: [{ type: "text", value: isDev ? "Last" : "" }],
    email: [{ type: "email", value: isDev ? "e@email.com" : "" }],
    phone: [{ type: "tel", mask: "(999)999-9999", value: "" }]
  },
  target: {
    firstName: [{ type: "text", value: isDev ? "Ffirst" : "" }],
    lastName: [{ type: "text", value: isDev ? "Llast" : "" }],
    email: [{ type: "email", value: isDev ? "b@email.com" : "" }],
    phone: [{ type: "tel", mask: "(999)999-9999", value: "" }]
  },
  response: {
    firstName: [{ type: "text", value: "" }],
    lastName: [{ type: "text", value: "" }],
    email: [{ type: "email", value: "" }],
    phone: [{ type: "tel", mask: "(999)999-9999", value: "" }]
  },
  payment: {
    token: {
      fields: {
        token: {
          hidden: true,
          value: ""
        }
      }
    },
    method: {
      label: "Payment method",
      fields: {
        cc_number: {
          type: "tel",
          mask: "9999 9999 9999 9999",
          label: "CREDIT CARD NUMBER",
          width: 70,
          value: isDev ? "4111111111111111" : "",
          validator: value => checkCreditCard(value)
        },
        cc_expDate: {
          type: "tel",
          mask: "99 / 99",
          label: "EXP.DATE",
          width: 30,
          value: isDev ? "11 / 22" : "",
          validator: value => validators.expiryDate(value)
        },
        cc_expDateMonth: { type: "hidden", label: "", width: 0 },
        cc_expDateYear: { type: "hidden", label: "", width: 0 },
        cvv_code: {
          type: "tel",
          mask: "999",
          label: "CVV",
          width: 20,
          value: isDev ? "123" : "",
          validator: value => value.length > 2
        }
      }
    },
    address: {
      label: "Billing address",
      fields: {
        bill_firstName: {
          type: "text",
          label: "FIRST NAME",
          width: 50,
          validator: value => validators.name(value)
        },
        bill_lastName: {
          type: "text",
          label: "LAST NAME",
          width: 50,
          validator: value => validators.name(value)
        },
        bill_email: {
          type: "email",
          label: "EMAIL",
          width: 100,
          validator: value => value.indexOf("@") > 0
        }
      }
    }
  },
  message: "",
  sections: {
    firstName: {
      label: "First name",
      key: "firstName",
      required: true,
      validator: value => value.length > 1
    },
    lastName: {
      label: "Last name",
      key: "lastName",
      required: true,
      validator: value => value.length > 1
    },
    email: {
      label: "Email",
      key: "email",
      required: true,
      validator: value => value.indexOf("@") !== -1
    },
    phone: {
      label: "Phone",
      key: "phone",
      validator: value =>
        new RegExp(/^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/).test(
          value
        )
    }
  }
};

const validatePage = (currentPage, state) => {
  for (let i = 0; i < Object.keys(state[currentPage]).length; i++) {
    let section = Object.keys(state[currentPage])[i];
    if (!section || section === "valid") continue;
    let isValid = state[currentPage][section].find(field => field.valid);
    if (state.sections[section].required && !isValid) {
      return false;
    }
  }
  return true;
};

const validatePayment = state => {
  console.log("validate payment:", state);
  for (let i = 0; i < Object.keys(state.payment.method.fields).length; i++) {
    let fieldId = Object.keys(state.payment.method.fields)[i],
      field = state.payment.method.fields[fieldId];
    if (field.hidden) continue;
    if (!field.valid) {
      return false;
    }
  }
  for (let i = 0; i < Object.keys(state.payment.address.fields).length; i++) {
    let fieldId = Object.keys(state.payment.address.fields)[i],
      field = state.payment.address.fields[fieldId];
    if (field.hidden) continue;
    if (!field.valid) {
      return false;
    }
  }
  return true;
};

export default function DetailsReducer(state = initialState, action) {
  switch (action.type) {
    case HTTP_REQUEST:
      return { ...state, loading: true };
    case HTTP_ERROR:
      return { ...state, loading: false, error: action.error };
    case HTTP_SUCCESS:
      return { ...state, loading: false };
    case SELECT_CHARITY:
      return { ...state, charity: action.payload };
    case DETAILS_ADD_FIELD: {
      let { currentPage, section } = action.payload;
      let newPage = { ...state[currentPage] };
      // limit inputs qty to 5
      if (newPage[section].length > 5) return state;

      newPage[section].push({ value: "" });
      if (currentPage === "response") {
        return { ...state, [currentPage]: newPage, target: { ...newPage } };
      } else {
        return { ...state, [currentPage]: newPage };
      }
    }
    case DETAILS_DELETE_FIELD: {
      let { currentPage, section, idx } = action.payload;
      let newPage = { ...state[currentPage] };
      newPage[section].splice(idx, 1);
      if (currentPage === "response") {
        return { ...state, [currentPage]: newPage, target: { ...newPage } };
      } else {
        return { ...state, [currentPage]: newPage };
      }
    }
    case DETAILS_ONCHANGE: {
      let { currentPage, section, value, idx } = action.payload;
      let newPage = { ...state[currentPage] };
      newPage[section][idx].value = value;
      if (currentPage === "response") {
        return { ...state, [currentPage]: newPage, target: { ...newPage } };
      } else {
        return { ...state, [currentPage]: newPage };
      }
    }
    case DETAILS_ONBLUR: {
      var { currentPage, section, value, idx } = action.payload,
        newPage = { ...state[currentPage] },
        selfDonation = false,
        dupeSections = [];
      newPage[section][idx].valid = state.sections[section].validator(value);
      if (state.value === "") newPage[section][idx].valid = undefined;
      newPage.valid = validatePage(currentPage, state);
      // fool protection again nartcisism
      if (value && ["email", "phone"].indexOf(section) !== -1) {
        const otherPage =
            currentPage === "personal" ? state.target : state.personal,
          otherPageValues = otherPage[section].map(field => field.value);
        if (!selfDonation) {
          selfDonation = !!newPage[section].find(
            field => otherPageValues.indexOf(field.value) !== -1
          );
          if (selfDonation) dupeSections.push(section);
        }
      }
      if (selfDonation) {
        dupeSections.map(dupeSection => {
          newPage[dupeSection][idx].valid = false;
        });
        newPage.valid = false;
      }
      if (currentPage === "response") {
        return { ...state, [currentPage]: newPage, target: { ...newPage } };
      } else {
        return { ...state, [currentPage]: newPage };
      }
    }
    case MESSAGE_ONCHANGE: {
      return { ...state, message: action.payload };
    }
    case PAYMENT_ONCHANGE: {
      let { section, field, value } = action.payload;
      let payment = { ...state.payment };
      payment[section].fields[field].value = value;
      return { ...state, payment };
    }
    case PAYMENT_ONBLUR: {
      let { section, field, value } = action.payload;
      let payment = { ...state.payment };
      payment[section].fields[field].value = value;
      payment[section].fields[field].valid = payment[section].fields[
        field
      ].validator(value);
      if (value === "") payment[section].fields[field].valid = undefined;
      switch (field) {
        case "cc_expDate": {
          if (payment[section].fields[field].valid) {
            payment[section].fields.cc_expDateMonth.value = +parseInt(
              value.split("/")[0] ? value.split("/")[0].trim() : 0
            );
            payment[section].fields.cc_expDateYear.value =
              2000 +
              parseInt(value.split("/")[1] ? value.split("/")[1].trim() : 0);
            payment[section].fields.cc_expDateMonth.valid = true;
            payment[section].fields.cc_expDateYear.valid = true;
          } else {
            payment[section].fields.cc_expDateMonth.valid = false;
            payment[section].fields.cc_expDateYear.valid = false;
          }
          break;
        }
        // case 'cc_number': {
        //     if (payment[section].fields[field].valid) {
        //         payment[section].fields.cc_type.value = getCardType(value);
        //         payment[section].fields.cc_type.valid = true;
        //     } else {
        //         payment[section].fields.cc_type.valid = false;
        //     }
        //     break;
        // }
      }
      payment.valid = validatePayment(state);
      return { ...state, payment };
    }
    case "@@router/LOCATION_CHANGE": {
      if (action.payload.pathname === "/") {
        return { ...initialState };
      }
      if (action.payload.pathname === "/payment") {
        const { valid, firstName, lastName, email } = state.personal;
        let payment = { ...state.payment };
        if (valid) {
          if (!payment.address.fields.bill_firstName.valid) {
            payment.address.fields.bill_firstName.value = firstName[0].value;
            payment.address.fields.bill_firstName.valid = true;
            payment.address.fields.bill_lastName.value = lastName[0].value;
            payment.address.fields.bill_lastName.valid = true;
          }
          if (!payment.address.fields.bill_email.valid) {
            payment.address.fields.bill_email.value = email[0].value;
            payment.address.fields.bill_email.valid = true;
          }
        }
        return { ...state, payment };
      }
      return state;
    }
    case DONATION_REQUEST_INIT: {
      return { ...state, loading: true };
    }
    case DONATION_REQUEST_SUCCESS: {
      const { status, isMatched, matchedData, error } = action.payload;
      if (status === "Success") {
        return {
          ...state,
          loading: false,
          success: true,
          isMatched,
          matchedData
        };
      } else {
        return { ...state, loading: false, error: error };
      }
    }
    case DONATION_REQUEST_ERROR: {
      return { ...state, loading: false, error: action.payload.error };
    }
    case RESPONSE_FETCH_REQUEST: {
      return { ...state, loading: true };
    }
    case RESPONSE_FETCH_SUCCESS: {
      let data = { ...state.personal };
      data.valid = true;
      Object.keys(action.payload).map(field => {
        var arrValues = action.payload[field];
        arrValues.map((value, idx) => {
          if (!value) return false;
          if (idx === 0) {
            data[field][0].value = value;
            data[field][0].valid = true;
          } else {
            const firstField = { ...data[field][0] };
            const newIdx = data[field].push(firstField);
            data[field][newIdx].value = value;
          }
        });
      });
      return { ...state, personal: data, loading: false, isResponse: true };
    }
    case RESPONSE_FETCH_ERROR: {
      return { ...state, loading: false, error: action.error };
    }
    case RESET_GLOBAL_STATE: {
      return initialState;
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./reducers/DetailsReducer.js